import i18n from "@/i18n";

const routes = {
  path: "/manager",
  name: "Manager",
  component: () =>
    import(/* webpackChunkName: "manager" */ "@/views/manager/Main"),
  children: [
    {
      path: "list",
      alias: "",
      name: "ManagerList",
      component: () =>
        import(/* webpackChunkName: "manager" */ "@/views/manager/List"),
      prop: true,
      meta: {
        location: "/manager/list",
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle: i18n.t("page.admin.admin_list"),
        step: [i18n.t("page.admin.admin"), i18n.t("page.admin.admin_list")],
        menu_num: 7,
        sub_menu_num: 71,
      },
    },
    {
      path: "write",
      name: "Adminwrite",
      component: () =>
        import(/* webpackChunkName: "manager" */ "@/views/manager/Write"),
      prop: true,
      meta: {
        location: "/manager/list",
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle: i18n.t("page.admin.admin_write"),
        step: [i18n.t("page.admin.admin"), i18n.t("page.admin.admin_list")],
        menu_num: 7,
        sub_menu_num: 71,
      },
    },
    {
      path: "edit/:adminno+",
      name: "Adminedit",
      component: () =>
        import(/* webpackChunkName: "manager" */ "@/views/manager/Write"),
      prop: true,
      meta: {
        location: "/manager/list",
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle: i18n.t("page.admin.admin_edit"),
        step: [i18n.t("page.admin.admin"), i18n.t("page.admin.admin_list")],
        menu_num: 7,
        sub_menu_num: 71,
      },
    },
    {
      path: "timezonelist",
      alias: "",
      name: "TimezoneList",
      component: () =>
        import(/* webpackChunkName: "manager" */ "@/views/timezone/List"),
      prop: true,
      meta: {
        location: "/manager/timezonelist",
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle: i18n.t("page.admin.timezonelist"),
        step: [i18n.t("page.admin.admin"), i18n.t("page.admin.timezonelist")],
        menu_num: 7,
        sub_menu_num: 73,
      },
    },
    {
      path: "timezonewrite",
      name: "TimezoneWrite",
      component: () =>
        import(/* webpackChunkName: "manager" */ "@/views/timezone/Write"),
      prop: true,
      meta: {
        location: "/manager/timezonelist",
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle: i18n.t("page.admin.timezonewrite"),
        step: [i18n.t("page.admin.admin"), i18n.t("page.admin.timezonewrite")],
        menu_num: 7,
        sub_menu_num: 73,
      },
    },
    {
      path: "timezoneedit/:timezone_pk+",
      name: "TimezoneEdit",
      component: () =>
        import(/* webpackChunkName: "manager" */ "@/views/timezone/Write"),
      prop: true,
      meta: {
        location: "/manager/timezonelist",
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle: i18n.t("page.admin.timezoneedit"),
        step: [i18n.t("page.admin.admin"), i18n.t("page.admin.timezoneedit")],
        menu_num: 7,
        sub_menu_num: 73,
      },
    },
    {
      path: "savingtimelist",
      alias: "",
      name: "SavingtimeList",
      component: () =>
        import(/* webpackChunkName: "manager" */ "@/views/savingtime/List"),
      prop: true,
      meta: {
        location: "/manager/savingtimelist",
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle: i18n.t("page.admin.savingtimelist"),
        step: [i18n.t("page.admin.admin"), i18n.t("page.admin.savingtimelist")],
        menu_num: 7,
        sub_menu_num: 74,
      },
    },
    {
      path: "savingtimewrite",
      name: "SavingtimeWrite",
      component: () =>
        import(/* webpackChunkName: "manager" */ "@/views/savingtime/Write"),
      prop: true,
      meta: {
        location: "/manager/savingtimelist",
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle: i18n.t("page.admin.savingtimewrite"),
        step: [
          i18n.t("page.admin.admin"),
          i18n.t("page.admin.savingtimewrite"),
        ],
        menu_num: 7,
        sub_menu_num: 74,
      },
    },
    {
      path: "savingtimeedit/:timezonedst_pk+",
      name: "savingtimeEdit",
      component: () =>
        import(/* webpackChunkName: "manager" */ "@/views/savingtime/Write"),
      prop: true,
      meta: {
        location: "/manager/savingtimelist",
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle: i18n.t("page.admin.savingtimeedit"),
        step: [i18n.t("page.admin.admin"), i18n.t("page.admin.savingtimeedit")],
        menu_num: 7,
        sub_menu_num: 74,
      },
    },
  ],
};

export default routes;
